import React from 'react';

import { SVGComponentProps } from './svg.types';

const EpicSVG = ({ fill = 'currentColor', size = '1em', ...otherProps }: SVGComponentProps) => {
  return (
    <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.5" width="20" height="20" rx="6" fill="#FD9740" />
      <path
        d="M6.5 13.75C6.5 13.4185 6.6317 13.1005 6.86612 12.8661C7.10054 12.6317 7.41848 12.5 7.75 12.5H14.5"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.75 5H14.5V15H7.75C7.41848 15 7.10054 14.8683 6.86612 14.6339C6.6317 14.3995 6.5 14.0815 6.5 13.75V6.25C6.5 5.91848 6.6317 5.60054 6.86612 5.36612C7.10054 5.1317 7.41848 5 7.75 5Z"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default EpicSVG;
